<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card configurator" v-bind:id="getId()" style="float:left; width:200px;">
    <div class="card-header bg-dark text-white header-elements-inline">
      <h6 class="card-title">{{$t('user_filter')}}</h6>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" @click="removeMe" data-action="remove"></a>
        </div>
      </div>
    </div>

    <div class="card-body">
      <user-selector @change="doChange" ref="selector"></user-selector>
      <div class="row mt-1">
        <div class="col px-0">
          <button class="btn btn-success btn-sm col-12" @click="doApply">{{$t('apply')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var config =
  {
    customstyle: "background-color:#12AEF5",
    customclass: "",
    abbreviation: "EB",
    data: 8,
    icon: null,
    text: "Erik Bohm"
  }

  import UserSelector from '../../user/user-selector.vue'

  export default {
    name: "config-user",
    components: {
      UserSelector
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      },
    },
    data() {
      return {
        config
      };
    },
    
    methods: {
      GetShortName(longname) {
        var tmpName = "";
        var nameArr = longname.trim().split(' ');
        tmpName = nameArr[0];
        for (var i = 1; i < nameArr.length; i++)
        {
          tmpName += " " + nameArr[i].substring(0, 1) + ".";
        }
        return tmpName;
      },
      GetAbbreviation(longname) {
        var nameArr = longname.trim().split(' ');
        var abbreviation = "";
        for (var i = 0; i < nameArr.length; i++)
        {
          abbreviation += nameArr[i].substring(0, 1);
        }
        return abbreviation;
      },
      doChange(val) {
        
        var items = this.$refs.selector.getData();
        for (var i = 0; i < items.length; i++) {
          if (items[i].Name.toString() == val.toString()) {
            this.config.data = items[i].Name;
            if (items[i].FullName != "") {
              this.config.text = this.GetShortName(items[i].FullName);
              this.config.abbreviation = this.GetAbbreviation(items[i].FullName)
            }
            else {
              this.config.text = items[i].Name;
              this.config.abbreviation = Name;
            }
            
          }
        }
      },
      doApply() {
        var configCopy =
        {
          customstyle: this.config.customstyle,
          customclass: this.config.customclass,
          abbreviation: this.config.abbreviation,
          data: this.config.data,
          icon: this.config.icon,
          text: this.config.text
        };

        this.$emit('addFilter', this.type, configCopy);
      },
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getId());
      }
    },
    computed: {
      
    },
    mounted() {
     
    },

    created: function () {

    },

    watch: {
     
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
      
    },
  };

</script>

<style scoped>

  .configurator {
    margin-left: 15px;
  }

  .card-header.bg-dark {
    background-color: #EAEDEF !important;
    color: black !important;
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/filter/configurators/config-user.vue